import React, { useRef } from 'react';
import { Grid, Container } from '@material-ui/core';
import { ButtonHLPure, HeaderHLPure, InputHLPure } from '../../pures';
import { useTranslation } from "react-i18next";
import { ExternalDropZone, Upload } from "@progress/kendo-react-upload"
import './client-profile.css';

const ClientProfileView = (props) => {
  const uploadRef = useRef();
  const { t: tCommon, i18n } = useTranslation('common');
  const { trans, isEditing, handleInputChange, onInputChange, toggleEditMode, onStatusChange, handleImageUpload } = props
  const {
    name,
    setName,
    image,
    setImage,
    imageSrc,
    emailContact,
    setEmailContact,
    telephoneNumber,
    setTelephoneNumber,
    categoriesCatalog,
  } = props

  let type;
  if (isEditing) {
    type = 'edit'
  }
  else {
    type = 'show'
  }

  const typeActionValidation = (type === 'show')
  let styleInputType = {}
  if (typeActionValidation) styleInputType = { backgroundColor: '#fafafa00', border: 'none', color: '#080808' }

  return (
    <Container className='view-container'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HeaderHLPure title={trans("title")} />
        </Grid>
        <Grid item xs={12}>
          <Container maxWidth={"md"}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <InputHLPure
                  labelInput={trans("name")}
                  typeInput="text"
                  valueInput={name}
                  handleChangeInput={(event) => onInputChange(event, setName)}
                  disabled={typeActionValidation}
                  showAsText={typeActionValidation}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <InputHLPure
                  labelInput={trans("contactEmail")}
                  typeInput="text"
                  valueInput={emailContact}
                  handleChangeInput={(event) => onInputChange(event, setEmailContact)}
                  disabled={typeActionValidation}
                  showAsText={typeActionValidation}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <InputHLPure
                  labelInput={trans("contactNumber")}
                  typeInput="number"
                  valueInput={telephoneNumber}
                  handleChangeInput={(event) => onInputChange(event, setTelephoneNumber)}
                  disabled={typeActionValidation}
                  showAsText={typeActionValidation}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <label className="loginForm-input-label">{trans("image")}</label>
                <div className="clientProfile-input-wrapper">
                  <div className="upload-image-container">
                    {
                      isEditing ? (
                        <>
                          {
                            imageSrc ? (
                              <div className='clientProfile-image-container'>
                                <img className="clientProfile-image-display" src={imageSrc} />
                              </div>
                            ) : (
                              <ExternalDropZone uploadRef={uploadRef} style={{ border: '3px dashed rgb(0 0 0 / 20%)', backgroundColor: '#00000000', color: 'rgb(0 0 0 / 40%)', fontWeight: '600', fontFamily: '"Quicksand"', height: "200px" }} />
                            )
                          }
                          <Upload className='upload-wrapper'
                            onStatusChange={onStatusChange}
                            ref={uploadRef}
                            batch={false}
                            multiple={false}
                            defaultFiles={[]}
                            withCredentials={false}
                            autoUpload={false}
                            showActionButtons={false}
                            accept=".heic,.png,.jpg,.jpeg,.mov"
                            onAdd={(ev) => {
                              if (ev.target.files[0]) {
                                const file = ev.target.files[0].getRawFile();
                                handleImageUpload(file);
                                setImage(file);
                              }
                            }}
                            onRemove={() => {
                              handleImageUpload(null);
                              setImage(null);
                            }}
                          />
                        </>
                      ) : (
                        <div className='clientProfile-image-container'>
                          <img className="clientProfile-image-display" src={image} />
                        </div>
                      )
                    }
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} className='button-actions'>
                {
                  !isEditing
                    ? <ButtonHLPure nameBtn={trans("editButton")} primary outlined onClick={toggleEditMode} />
                    : <>
                      <ButtonHLPure nameBtn={trans("cancelButton")} colorScheme='error' outlined onClick={toggleEditMode} />
                      <ButtonHLPure nameBtn={trans("acceptButton")} primary onClick={handleInputChange} />
                    </>
                }
              </Grid>
            </Grid>
          </Container>
        </Grid>
      </Grid>
    </Container>
  );
};

export { ClientProfileView as default };